export default __webpack_public_path__ + "static/media/plain-green.c88cdbd8.jpg";